import { axiosInstance } from "../../utils/axios";
import { AnalyticalWorkspace } from "../models/analytical-workspace";
import { getVersionedApiUrl } from "../../utils/helpers/ApiResolver";

export function fetchAnalyticalWorkspaces(dbId: string, descriptionLanguage: string): Promise<AnalyticalWorkspace[]> {
  return axiosInstance
    .get(`${getVersionedApiUrl("/analyticalworkspaces")}/${dbId}?descriptionLanguage=${descriptionLanguage}`)
    .then((response) => response.data);
}
